import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "./api";

const getTokenFromLocalStorage = () => {
  return localStorage.getItem("token");
};

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/orders`,
    prepareHeaders: (headers) => {
      const token = getTokenFromLocalStorage();
      if (token) {
          headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
  },
  }),
  tagTypes: ["Order"],
  endpoints: (builder) => ({
    orders: builder.query({
      query: (data) => `/?page=${data?.page}&perPage=${10}`,
      providesTags: ["Order"],
    }),
    getOrderById: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["Order"],
    }),
    addOrder: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    markShipped: builder.mutation({
      query: (data) => ({
        url: "/mark-shipped",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    makePayment: builder.mutation({
      query: (data) => ({
        url: "/make-payment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    updateOrder: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    deleteOrder: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Order"],
    }),
  }),
});
export const {
  useOrdersQuery,
  useGetOrderByIdQuery,
  useMakePaymentMutation,
  useAddOrderMutation,
  useMarkShippedMutation,
} = orderApi;
